import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useEffect, useState } from "react";
import { MediaUrl } from "../utils/media/Media";
import CGU from "./CGU.md";
import CGV from "./CGV.md";
import { useFetch } from "../api/FetchApiData";
import { isMobile } from "react-device-detect";

if (isMobile)
    import('./cgu_mob.css').then(() => {}).then(() => {});
else
    import('./cg.css').then(() => {}).then(() => {});

export default function CG({close=()=>{},display_close_button=true}) {
  const [content, setContent] = useState("");
  const [headings, setHeadings] = useState([]);
  const fetch_data = useFetch();

  const slugify = (text) =>
  text
    .toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // enlève accents
    .replace(/[^\w\s-]/g, "") // enlève caractères spéciaux
    .trim()
    .replace(/\s+/g, "-");

  useEffect(() => {
    fetch_data.GetData("cg/")
      .then(result => {
        if(!result.result)
          return
        var text = result.text;
        setContent(text);
        const lines = text.split("\n");
        const extracted = lines
          .filter(line => /^##\s/.test(line))
          .map(line => {
            const title = line.replace(/^##\s/, "");
            const id = title.toLowerCase().replace(/\s+/g, "-");
            return { title, id: slugify(title) };
          });
        setHeadings(extracted);
      });
  }, []);

  return (
    <div className="layout" style={{}}>
      
      {/* Sommaire 
      <nav className="toc">
        <h3>Sommaire</h3>
        <ul>
          {headings.map(h => (
            <li key={h.id}>
              <a href={`#${h.id}`}>{h.title}</a>
            </li>
          ))}
        </ul>
      </nav>
      */}
      {/* Contenu */}
      <div className="content">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            h2: ({ children }) => {
              const text = children.toString();
              return <h2 id={slugify(text)}>{children}</h2>;
            }
          }}
        >
          {content}
        </ReactMarkdown>
        {display_close_button && (
          <input type="button" value="Fermer" onClick={close} style={{border:'none',borderRadius:'5px',backgroundColor:'rgb(250, 123, 123)',marginTop:'20px',padding:'8px 40px'}} />
        )}
      </div>
    </div>
  );
}